import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsxs("g", { stroke: "currentColor", strokeWidth: "2.25", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ o.jsx("path", { d: "M12.229 12.198A9.75 9.75 0 1 1 21.2 21.17" }),
  /* @__PURE__ */ o.jsx("path", { d: "M31.7 24.199a4.5 4.5 0 0 1-4.5 4.5h-3m0 0 3-3m-3 3 3 3M1.7 9.199a4.5 4.5 0 0 1 4.5-4.5h3m0 0L6.2 7.7m3-3-3-3.001m5.25 30a9.75 9.75 0 1 1 0-19.5 9.75 9.75 0 0 1 0 19.5" })
] }) });
export {
  s as S
};
